import * as H from "history";
import {miniPersistStore} from "./MiniPersistStore";
import {message} from "antd";
import {consoleApi} from "../apiMiddleware";
import {observable} from "mobx";
import {ResPutData} from "./LoginStore";
import { getCurrentLan } from "@netless/i18n-react-router";

export type RegisterResData = {
    code: number;
    data: any;
};

export type ResCode = {
    code: number,
    data: {
        success: boolean,
    };
};

export type RegisterDataType = {
    email: string,
    phone: string,
    code: string,
    password: string,
    passwordAgain: string,
    currency: string,
};

export class RegisterStore {

    @observable
    public registerLoadingState: boolean = false;
    public async doSendCode(region: string, phone: string): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const resp: ResCode = await consoleApi.user.sendCode(region, phone);
            if (resp.code === 200) {
                message.success(isEnglish ? "Verification code sent successfully" : "验证码发送成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    private async sendMail(): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const res: ResPutData = await consoleApi.user.sendEmail();
            if (res.code === 200) {
                message.success(isEnglish ? "Send verification email successfully" : "发送验证邮件成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }


    public async register(history: H.History, registerData: RegisterDataType): Promise<void> {
        try {
            this.registerLoadingState = true;
            const resp: RegisterResData = await consoleApi.user.registerUserData({
                email: registerData.email,
                phone: registerData.phone,
                code: registerData.code,
                password: registerData.password,
                passwordAgain: registerData.passwordAgain,
                currency: registerData.currency,
            });
            if (resp.code === 200 && resp.data.miniToken) {
                miniPersistStore.token = resp.data.miniToken;
                history.push(`/register/step-two/${registerData.email}/`);
                await this.sendMail();
            } else {
                message.error(resp.data);
            }

        } catch (err) {
            message.error(err.message);
        } finally {
            this.registerLoadingState = false;
        }
    }
}
export const registerStore = new RegisterStore();



// WEBPACK FOOTER //
// ./src/models/RegisterStore.ts